module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch3"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch3.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("T")]), _vm._v("he white stretched out beneath Molly Davis in endless sheets.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In some places the snow lay in waves, like sand dunes carved smooth by the wind. In others, ice rose up from colliding floes in jagged, broken spires. The sun was just above the horizon and cast long shadows across rippling white.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Molly shivered, looking at all that ice. According to the flight tracker map on her video screen, the plane was well above the Arctic Circle now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No cities. No roads. She hadn’t seen anything but arctic white in ages.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which raised an interesting question. If Javi’s worst fears came true and the plane crashed, would the passengers freeze to death before help arrived?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Molly looked around the cabin. It was June, so nobody was wearing anything heavier than a sweater. And those flimsy airplane blankets wouldn’t even keep you warm in a movie theater.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe you could make survival tents out of the life rafts pictured on the safety card. Or keep yourself warm with jet fuel. Was there a way to burn it steadily? Or would you just blow yourself up, along with what remained of the plane?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She turned from the window to ask Javi for help with the problem, but he was still asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That was annoying. He’d been jittering like a bag of windup teeth all morning, but now that Molly was bored he was unconscious.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was better than him sulking, she supposed. Ever since Team Killbot had won the championship by default, he’d acted like they weren’t really winners. Like they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("deserved")]), _vm._v(" for things to go wrong in Tokyo. Well, the other finalists’ bad luck wasn’t Team Killbot’s fault.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s what you got for making fragile robots. You could ship the Killbots a thousand miles in the back of a bouncy UPS truck, and they’d probably work just fine. They were simple. And they kicked butt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("That")]), _vm._v(" was how good engineers built things.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Molly looked back at Oliver and Anna, hoping that one of them was awake. Nope, they were asleep, too. Even Mr. Keating was snoring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turned out that fourteen hours was a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("long")]), _vm._v(" time. Molly hated having no one to talk to. At home when Mom got quiet, Molly sometimes even talked to herself, answering her own questions. Anything was better than silence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked down at the ice and shivered again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Javi let out a sputtery snore, and Molly wondered if she should get some sleep, too. Team Killbot’s first match was the day after they landed, and she had no idea what jet lag felt like. Javi wasn’t the only kid at Brooklyn Science and Tech who’d never flown before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shut the window shade against the endless white and settled back into her seat. The airplane pillow smelled weird, so she dropped it on the floor and scrunched up her sweater.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With the steady roar of the plane in her ears, Molly could almost imagine falling asleep …")]), _vm._v(" "), _c('p', {
    staticClass: "spaceOrnament",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/sborn.jpg",
      "width": "15%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In her dream, snow still rolled beneath the airplane, endless and empty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Molly could see everything now, not only through her little window, but in all directions. She saw the ice floes stirred by the ocean beneath them, pushed by the winds spinning around the globe. From up here, the forces that shaped the ice all made so much "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sense")]), _vm._v(", like when she grasped a solution to an engineering problem.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But there was something ahead that didn’t make any sense at all. Out there in the snow, a hundred miles away, something was waiting. Something that reminded Molly of her mother—lonely, angry at fate, and a little confused.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it knew what it wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It reached out, grasping with lines of pure force …")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("… for the airplane.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A jolt went through Molly’s body, along with a blazing white in her mind as bright as the snow outside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thing out there in the ice, its claws were "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("inside")]), _vm._v(" the plane now—slicing and cutting along the seams, setting those hundreds of miles of wire aflame, bending the course of the shuddering aircraft by sheer force of will.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then the blaze of its attention turned from the shell of metal and saw "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v(", Molly Davis. It reached straight into her mind, lighting up her brain. Like it wanted to know her …")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Molly awoke gasping from the dream, but out here in the real world, things were just as bewildering. The cabin lights pulsed and flickered, and the plane was shuddering beneath her. Smoke filled the air.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No way.” She turned to Javi. “Am I awake?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I sure am.” His face was pale.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("One in ten million")]), _vm._v(", Molly thought. Those were the odds of a jetliner going down, according to her trivia book. She was about to say it out loud when the shriek of an alarm filled the cabin, and five hundred oxygen masks suddenly tumbled from the ceiling. They danced and swung with the rocking of the airplane, like a chorus of horrible puppets flailing among the light and smoke and noise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a rubber jungle, and everybody started screaming.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-217806ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545916790_ch003.vue
// module id = 81
// module chunks = 0